// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getProgressBarPercentage(
  value?: number,
  maxValue?: number,
) {
  let percentage = 0;
  if (value !== undefined && maxValue !== undefined) {
    percentage = Math.round((value / maxValue) * 100);
    if (percentage < 0) {
      percentage = 0;
    }
  }

  return percentage;
}
